import { sb } from '@/hooks/useSupabaseQuery';

export interface OptionTickerRow {
  symbol: string;
  strike: number;
  side: 'C' | 'P';
  bid: number;
  bid_size: number | null;
  ask: number;
  ask_size: number | null;
  mark: number | null;
  mark_iv: number | null;
  delta: number | null;
  gamma: number | null;
  vega: number | null;
  theta: number | null;
  index_price: number | null;
}

export interface OptionsSnapshot {
  underlying: string;
  fetched_at: string;
  expiries: string[];
  selected_expiry: string | null;
  rows: OptionTickerRow[];
}

export async function fetchOptionsSnapshot(
  underlying: string,
  expiry?: string,
): Promise<OptionsSnapshot> {
  const { data, error } = await sb.functions.invoke('options-snapshot', {
    body: { underlying, expiry },
  });

  if (error) {
    throw new Error(error.message);
  }

  if (!data || typeof data !== 'object') {
    throw new Error('Empty response from options-snapshot');
  }

  if ('error' in data && data.error) {
    const message = typeof data.message === 'string' && data.message
      ? data.message
      : String(data.error);
    throw new Error(message);
  }

  return data as OptionsSnapshot;
}
